import {onBreadcrumbClick} from '../../components/common/di-ding/_nav-maps'

export const routeNameOfDi = {
  APP_CENTER_ACCESS_CTRL_EQUIPMENT_MANAGEMENT: 'app-center-access-ctrl-equipment-management',
  APP_CENTER_ACCESS_CTRL_EMPOWERMENT: 'app-center-access-ctrl-empowerment',
  APP_CENTER_ACCESS_CTRL_EMPOWERMENT_ENTERPRISE: 'app-center-access-ctrl-empowerment-enterprise',
  APP_CENTER_ACCESS_CTRL_FACE_AUTHORITY: 'app-center-access-ctrl-face-authority',
  APP_CENTER_ACCESS_CTRL_FACE_AUTHORITY_ENTERPRISE: 'app-center-access-ctrl-face-authority-enterprise',
  APP_CENTER_ACCESS_CTRL_KEYPAD_INTEGRATION: 'app-center-access-ctrl-keypad-integration',
  APP_CENTER_ACCESS_CTRL_KEYPAD_INTEGRATION_ENTERPRISE: 'app-center-access-ctrl-keypad-integration-enterprise',
  APP_CENTER_ACCESS_CTRL_FACE_ISSUE: 'app-center-access-ctrl-face-issue',
  APP_CENTER_ACCESS_CTRL_OPEN_RECORD: 'app-center-access-ctrl-open-record',
  APP_CENTER_ACCESS_CTRL_CALL_POLICE: 'app-center-access-ctrl-call-police',
  APP_CENTER_ACCESS_CTRL_DEVICE_STATUS: 'app-center-access-ctrl-device-status',
  APP_CENTER_ACCESS_CTRL_OPEN_CONFIG: 'app-center-access-ctrl-open-config'
}

export const commonConfig = {
  firstBreadcrumb: {
    label: '智慧门禁',
    onClick: onBreadcrumbClick
  }
}



// WEBPACK FOOTER //
// ./src/view/AccessCtrl/common.js